import { showErrorAlert } from "../helpers/alert";
import apiClient from "../helpers/apiClient";
import { UserTeamModel } from "../pages/myTeam/models/UserTeamModel";
import { TeamModel } from "../pages/team/models/TeamModel";
import { handleApiError, parseApiErrors } from "../utils/handleApiError";


export async function createUserTeam(
    payload: TeamModel
) {
    const { data } = await apiClient.post(`/users/team/`, payload);
    return data;
}

export async function getUserTeam(): Promise<TeamModel[]> {
    const { data } = await apiClient.get(`/users/team/`,);
    return data;
}

/* Final User */
export async function getMyTeamFinalUser(params:any){
    try {
        const { data } = await apiClient.get(`/moderation/teams/me/`,{params: params});
        return data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function createUserTeamForFinalUser(teamId:number, data: any) {
    try {
        const response = await apiClient.post(`/moderation/teams/${teamId}/invite/`, data);
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }    
}

export async function updateUserTeamForFinalUser(teamId:number,membershipId:number,data: any) {
    try {
        let headers = { 
            Accept: 'application/json',
            "Content-Type": "application/json",
        };
        const response = await apiClient.put(`/moderation/teams/${teamId}/members/${membershipId}/`, data,{ headers: headers });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

/* export async function updateUserTeamForFinalUser(teamId:number, data: any) {
    try {
        const response = await apiClient.put(`/moderation/teams/${teamId}/invite/`, data);
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }    
} */

export async function getUserByMyTeamFinalUser(teamId: number, membershipId: number): Promise<UserTeamModel> {
    const response = await apiClient.get(`/moderation/teams/${teamId}/invite/${membershipId}/`, {});
    return response.data;
}

export async function getTeamByTeamId(teamId:number){
    try {
        const { data } = await apiClient.get(`/moderation/teams/${teamId}/members/`);
        return data;
    } catch (error) {
        handleApiError(error, {});
    }
}